<template>
	<div
		class="rich-text"
		:class="blok.textAlign || ''"
		v-html="blockContent"
	></div>
</template>

<script setup lang="ts">
import type { BlokRichText } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokRichText;
}
const { blok } = defineProps<Props>();

const blockContent = computed(() => renderRichText(blok.content));
</script>
